import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "dot", "prev", "next"]

  connect() {
    this.index = 0
    this.trackTarget.addEventListener("scroll", this._onScroll.bind(this))
  }

  prev() {
    this._goToIndex(this.index - 1)
  }

  next() {
    this._goToIndex(this.index + 1)
  }

  goTo(event) {
    this._goToIndex(parseInt(event.currentTarget.dataset.index))
  }

  _goToIndex(i) {
    const track = this.trackTarget
    const slideWidth = track.children[0]?.offsetWidth || 0
    track.scrollTo({ left: slideWidth * i, behavior: "smooth" })
  }

  _onScroll() {
    const track = this.trackTarget
    const slideWidth = track.children[0]?.offsetWidth || 1
    const newIndex = Math.round(track.scrollLeft / slideWidth)

    if (newIndex !== this.index) {
      this.index = newIndex
      this._updateDots()
      this._updateArrows()
    }
  }

  _updateDots() {
    this.dotTargets.forEach((dot) => {
      const slideIndex = parseInt(dot.dataset.index)
      dot.classList.toggle("wallet-dots__dot--active", slideIndex === this.index)
    })
  }

  _updateArrows() {
    const total = this.trackTarget.children.length
    this.prevTargets.forEach(btn => btn.hidden = this.index === 0)
    this.nextTargets.forEach(btn => btn.hidden = this.index >= total - 1)
  }
}
